export const JAYCHIS_LOGO: string = 'https://i.ibb.co/rHPPfvt/download.webp';